import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=3fc7be2f&scoped=true&lang=pug&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=3fc7be2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7be2f",
  null
  
)

export default component.exports